import type { InvoiceFilterInput } from '@/integrations/faturamento/client';

/**
 * Escopo de gerador do extrato (`/billing/generator/cycles`), o mesmo na tabela e no CSV.
 *
 * Unidade escolhida à mão vale sozinha: já está dentro do gerador selecionado, e mandar os dois
 * deixaria a resposta à mercê de a API cruzar (E) ou somar (OU) os filtros. Sem unidade, vai o
 * gerador em `generator_id` — a API expande a subárvore. O front nunca traduz gerador em lista de
 * filiais: um gerador com centenas de lojas estourava a URL (414).
 */
export function invoiceScopeFilter(
  generatorIds: number[] | undefined,
  establishmentIds: number[] | undefined,
): Pick<InvoiceFilterInput, 'generator_id' | 'establishment_ids'> {
  if (establishmentIds?.length) return { establishment_ids: establishmentIds };
  if (generatorIds?.length) return { generator_id: generatorIds };
  return {};
}
